<template>
  <div>
    <SnackbarComp :SnackbarComponent="SnackbarComponent" />
    <v-dialog
      density="compact"
      v-model="internalDialog"
      :max-width="1200"
      persistent
    >
      <v-card class="rounded-lg d-flex flex-column">
        <v-card-title
          class="d-flex align-center bg-primary text-white pa-2 text-subtitle-1 font-weight-bold flex-shrink-0"
        >
          <v-icon class="mr-2" size="small">mdi-poll</v-icon>
          {{ selectedPoll?.type === "edit" ? "Edit Poll" : "Create New Poll" }}
          <v-spacer></v-spacer>
          <v-btn variant="text" size="small" icon @click="closeDialog">
            <v-icon>mdi-close-thick</v-icon>
          </v-btn>
        </v-card-title>

        <v-row density="compact" class="overflow-y-auto mx-0">
          <v-col cols="12" md="8" class="pa-0">
            <v-card-text class="pa-3 flex-grow-1 overflow-y-auto">
              <v-form ref="pollForm">
                <v-row density="compact">
                  <v-col cols="12" md="12" sm="12" class="py-1 mt-4 pb-3">
                    <v-text-field
                      v-model="formData.title"
                      label="Poll Question *"
                      density="compact"
                      variant="outlined"
                      :rules="[required]"
                      prepend-inner-icon="mdi-help-circle"
                      counter="100"
                      maxlength="100"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12" sm="12" class="py-0">
                    <v-row density="compact" class="py-0">
                      <v-col
                        cols="6"
                        sm="4"
                        md="3"
                        v-for="(option, index) in formData.options"
                        :key="index"
                        class="py-0"
                      >
                        <v-text-field
                          v-model="formData.options[index]"
                          :label="`Option ${index + 1}`"
                          density="compact"
                          maxlength="40"
                          counter
                          variant="outlined"
                          hide-details="auto"
                          :rules="[(v) => !!v || 'Empty']"
                        >
                          <template v-slot:append-inner>
                            <v-icon
                              v-if="formData.options.length > 2"
                              color="error"
                              size="small"
                              class="cursor-pointer"
                              @click="removeOption(index)"
                              >mdi-close</v-icon
                            >
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="6" sm="4" md="3" class="py-0">
                        <v-btn
                          variant="tonal"
                          color="primary"
                          prepend-icon="mdi-plus"
                          :disabled="formData.options.length >= 5"
                          @click="addOption"
                          >Add Option</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" md="12" sm="12">
                    <v-text-field
                      v-model="formData.knowledge_base_url"
                      label="External Link (Optional)"
                      density="compact"
                      variant="outlined"
                      hide-details="auto"
                      prepend-inner-icon="mdi-link-box"
                      :disabled="selectedPoll?.type === 'edit'"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col
                    :cols="formData.category == 'Others' ? 12 : 6"
                    :md="formData.category == 'Others' ? 4 : 6"
                    :sm="formData.category == 'Others' ? 4 : 6"
                    class="pt-2"
                  >
                    <v-select
                      v-model="formData.category"
                      :items="categories"
                      label="Category *"
                      density="compact"
                      variant="outlined"
                      hide-details="auto"
                      :rules="[(v) => !!v || 'Required']"
                      prepend-inner-icon="mdi-shape"
                    ></v-select>
                  </v-col>
                  <v-col
                    :cols="formData.category == 'Others' ? 12 : 6"
                    :md="formData.category == 'Others' ? 4 : 6"
                    :sm="formData.category == 'Others' ? 4 : 6"
                    class="pt-2"
                    v-if="formData.category == 'Others'"
                  >
                    <v-text-field
                      v-model="otherCategory"
                      label="Specify Category *"
                      density="compact"
                      variant="outlined"
                      hide-details="auto"
                      :rules="[(v) => !!v || 'Required']"
                      prepend-inner-icon="mdi-shape"
                    ></v-text-field>
                  </v-col> -->
                </v-row>
                <v-row density="compact" class="rounded mx-0 px-0">
                  <v-col cols="6" sm="3" class="py-1 pl-0">
                    <v-select
                      v-model="formData.age_group"
                      :items="['18-30', '30-50', '50+', 'ALL']"
                      label="Age Group *"
                      density="compact"
                      variant="outlined"
                      hide-details="auto"
                      :rules="[(v) => !!v || 'Required']"
                      prepend-inner-icon="mdi-account-group"
                      :disabled="selectedPoll?.type === 'edit'"
                    ></v-select>
                  </v-col>
                  <v-col cols="6" sm="3" class="py-1">
                    <v-autocomplete
                      :disabled="isCountryDisabled"
                      v-model="selectedCountry"
                      label="Country"
                      :items="['ALL', 'India', 'United States']"
                      density="compact"
                      variant="outlined"
                      hide-details="auto"
                      @update:modelValue="onCountryChange"
                    ></v-autocomplete>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="3"
                    v-if="selectedCountry !== 'ALL'"
                    class="py-1"
                  >
                    <v-autocomplete
                      :disabled="isStateDisabled"
                      v-model="selectedState"
                      label="State"
                      :items="['ALL', ...availableStates]"
                      density="compact"
                      variant="outlined"
                      hide-details="auto"
                      @update:modelValue="onStateChange"
                    ></v-autocomplete>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="3"
                    v-if="selectedCountry !== 'ALL' && selectedState !== 'ALL'"
                    class="py-1"
                  >
                    <v-autocomplete
                      :disabled="isDistrictDisabled"
                      v-model="selectedDistrict"
                      label="District"
                      :items="['ALL', ...availableDistricts]"
                      density="compact"
                      variant="outlined"
                      hide-details="auto"
                      @update:modelValue="onDistrictChange"
                    ></v-autocomplete>
                  </v-col>

                  <v-col
                    cols="6"
                    sm="3"
                    v-if="
                      selectedCountry !== 'ALL' &&
                      selectedState !== 'ALL' &&
                      selectedDistrict !== 'ALL'
                    "
                    class="py-1 pl-0"
                  >
                    <v-autocomplete
                      :disabled="isPincodeDisabled"
                      v-model="selectedPincode"
                      label="Pincode"
                      :items="['ALL', ...availablePincodes]"
                      density="compact"
                      variant="outlined"
                      hide-details="auto"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row density="compact">
                  <v-col cols="12" sm="8" class="pt-2">
                    <v-menu
                      v-model="startDateTimeMenu"
                      :close-on-content-click="false"
                      offset-y
                      eager
                    >
                      <template v-slot:activator="{ props }">
                        <v-text-field
                          v-bind="props"
                          :disabled="selectedPoll?.type === 'edit'"
                          :value="
                            formatDateTime(
                              formData.startDate,
                              formData.start_time,
                            )
                          "
                          placeholder="Poll Start Date & Time *"
                          density="compact"
                          variant="outlined"
                          hide-details="auto"
                          prepend-inner-icon="mdi-calendar-clock"
                          readonly
                          :rules="[
                            () =>
                              formData.startDate && formData.start_time
                                ? true
                                : 'Required',
                          ]"
                        ></v-text-field>
                      </template>

                      <v-card class="pa-2 pb-0">
                        <v-row class="my-0 py-0" density="compact">
                          <v-col cols="12" sm="6" class="pa-1">
                            <div
                              class="text-caption font-weight-bold mb-1 text-center"
                            >
                              Start Date
                            </div>
                            <v-date-picker
                              v-model="formData.startDate"
                              :min="minDate"
                              density="compact"
                              color="primary"
                              class="custom-date-picker w-100"
                            ></v-date-picker>
                          </v-col>
                          <v-col cols="12" sm="6" class="pa-1">
                            <div
                              class="text-caption font-weight-bold mb-1 text-center"
                            >
                              Start Time
                            </div>
                            <v-time-picker
                              v-model="formData.start_time"
                              :allowed-hours="allowedHours"
                              :allowed-minutes="allowedMinutes"
                              density="compact"
                              format="ampm"
                              ampm-in-title
                              color="primary"
                              class="custom-time-picker w-100"
                            ></v-time-picker>
                          </v-col>
                        </v-row>
                        <v-divider class="my-2"></v-divider>
                        <div class="d-flex justify-end gap-2 px-2 pb-1">
                          <v-btn
                            variant="outlined"
                            size="small"
                            @click="clearDateTime"
                            >Cancel</v-btn
                          >
                          <v-btn
                            color="primary"
                            variant="flat"
                            size="small"
                            :disabled="!isValidDateTime"
                            @click="startDateTimeMenu = false"
                            class="btn-primary-gradient"
                          >
                            Confirm
                          </v-btn>
                        </div>
                      </v-card>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="4" class="pt-2">
                    <v-autocomplete
                      v-model="formData.pollEnsIn"
                      :disabled="selectedPoll?.type === 'edit'"
                      :items="
                        Array.from({ length: 24 }, (_, i) => `${i + 1} hours`)
                      "
                      label="Poll Duration *"
                      density="compact"
                      variant="outlined"
                      hide-details="auto"
                      prepend-inner-icon="mdi-timer-outline"
                      :rules="[() => (formData.pollEnsIn ? true : 'Required')]"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-form>

              <div
                class="mt-4 pa-2 mb-2 rounded-lg border bg-grey-lighten-5 d-flex align-center justify-space-between"
              >
                <div class="d-flex align-center">
                  <v-avatar
                    color="primary"
                    variant="tonal"
                    size="32"
                    class="mr-3"
                  >
                    <v-icon
                      size="small"
                      :icon="
                        formData.enable_app_notification
                          ? 'mdi-bell-ring'
                          : 'mdi-bell-off'
                      "
                    ></v-icon>
                  </v-avatar>
                  <div>
                    <div
                      class="text-body-2 font-weight-bold text-grey-darken-3"
                      style="line-height: 1.2"
                    >
                      Push Notifications
                    </div>
                    <div class="text-caption text-grey-darken-1">
                      Send alerts to users for this poll
                    </div>
                  </div>
                </div>
                <v-switch
                  v-model="formData.enable_app_notification"
                  color="primary"
                  density="compact"
                  hide-details
                  inset
                ></v-switch>
              </div>
            </v-card-text>
          </v-col>
          <v-col cols="12" md="4" class="mt-2">
            <!-- <v-card variant="outlined" height="400" class="overflow-y-auto">
              <v-card-title class="text-subtitle-1 font-weight-bold pb-0">
                Ask AI Assistant
              </v-card-title>

              <v-card-text>
                <v-textarea
                  v-model="aiPrompt"
                  placeholder="Enter your prompt here..."
                  density="compact"
                  variant="outlined"
                  rows="3"
                  hide-details
                  class="mt-2 mb-3"
                ></v-textarea>

                <div class="d-flex justify-end mb-4">
                  <v-btn
                    color="primary"
                    variant="tonal"
                    @click="submitPrompt"
                    :loading="isGenerating"
                    :disabled="!aiPrompt.trim()"
                  >
                    Generate Response
                  </v-btn>
                </div>

                <v-expand-transition>
                  <div v-if="aiResponse">
                    <v-divider class="mb-3"></v-divider>
                    <v-sheet
                      color="grey-lighten-4"
                      class="pa-4 rounded border"
                      min-height="100"
                    >
                      <div class="text-body-2" style="white-space: pre-wrap">
                        {{ aiResponse }}
                      </div>
                    </v-sheet>
                  </div>
                </v-expand-transition>
              </v-card-text>
            </v-card> -->
            <v-card
              variant="outlined"
              height="375"
              class="d-flex flex-column rounded-lg border-opacity-50 overflow-hidden bg-white"
            >
              <div class="flex-shrink-0 position-relative" style="z-index: 10">
                <v-tabs
                  v-model="activeTab"
                  bg-color="grey-lighten-5"
                  color="deep-purple-accent-2"
                  grow
                >
                  <v-tab value="scratchpad" class="text-none font-weight-bold">
                    <v-icon start>mdi-notebook-edit-outline</v-icon> Scratchpad
                  </v-tab>
                  <v-tab value="ai" class="text-none">
                    <v-icon
                      start
                      icon="mdi-sparkles"
                      class="ai-gradient-text"
                      :class="{
                        'ai-pulse-animation':
                          isGenerating && activeTab === 'ai',
                      }"
                    ></v-icon>
                    <span class="font-weight-bold ai-gradient-text"
                      >Ask AI</span
                    >
                  </v-tab>
                </v-tabs>
                <v-divider></v-divider>
              </div>

              <v-card-text
                class="flex-grow-1 overflow-y-auto pa-0 bg-grey-lighten-5"
                style="min-height: 0"
              >
                <v-window v-model="activeTab" class="h-100">
                  <v-window-item value="scratchpad">
                    <div class="pa-4 h-100">
                      <v-textarea
                        v-model="formData.description"
                        placeholder="Use this scratch pad to draft ideas or write notes..."
                        variant="solo"
                        elevation="0"
                        bg-color="white"
                        hide-details
                        rows="11"
                        class="rounded-lg border"
                      ></v-textarea>
                    </div>
                  </v-window-item>

                  <v-window-item value="ai" class="h-100">
                    <div class="d-flex flex-column h-100">
                      <div class="flex-grow-1 overflow-y-auto mb-2 pe-2">
                        <div
                          v-if="!aiResponse && !isGenerating"
                          class="h-100 d-flex flex-column align-center justify-center text-center opacity-80"
                        >
                          <v-avatar
                            color="deep-purple-lighten-5"
                            size="64"
                            class="mb-4"
                          >
                            <v-icon
                              icon="mdi-robot-outline"
                              size="32"
                              color="deep-purple-accent-2"
                            ></v-icon>
                          </v-avatar>
                          <div
                            class="text-subtitle-1 font-weight-bold text-grey-darken-2 mb-1"
                          >
                            How can I help you?
                          </div>
                          <div class="text-body-2 text-grey mb-6">
                            Try one of these prompts to get started:
                          </div>
                          <div
                            class="d-flex flex-wrap justify-center"
                            style="max-width: 300px; gap: 8px"
                          >
                            <v-chip
                              @click="
                                aiPrompt = 'Give me 3 polls about remote work'
                              "
                              variant="outlined"
                              color="deep-purple"
                              size="small"
                              class="bg-white"
                              >🏢 Remote Work Polls</v-chip
                            >
                            <v-chip
                              @click="
                                aiPrompt =
                                  'What are good questions for a tech event?'
                              "
                              variant="outlined"
                              color="deep-purple"
                              size="small"
                              class="bg-white"
                              >💻 Tech Event Q's</v-chip
                            >
                          </div>
                        </div>

                        <div v-if="isGenerating" class="mt-2">
                          <v-skeleton-loader
                            v-for="i in 2"
                            :key="'skel' + i"
                            type="list-item-two-line, text, actions"
                            class="mb-2 ma-2 rounded-xl border bg-white"
                            elevation="0"
                          ></v-skeleton-loader>
                        </div>

                        <v-slide-y-transition group>
                          <div
                            v-if="
                              !isGenerating &&
                              parsedAiPolls &&
                              parsedAiPolls.length > 0
                            "
                          >
                            <v-card
                              v-for="(poll, index) in parsedAiPolls"
                              :key="'poll' + index"
                              variant="flat"
                              class="ma-2 bg-white border ai-poll-card transition-swing rounded-xl"
                            >
                              <v-card-text class="pa-2">
                                <div class="d-flex align-start mb-3">
                                  <v-avatar
                                    size="24"
                                    color="deep-purple-lighten-5"
                                    class="me-3 mt-1"
                                  >
                                    <span
                                      class="text-caption font-weight-bold text-deep-purple"
                                    >
                                      {{ poll.poll_number || index + 1 }}
                                    </span>
                                  </v-avatar>
                                  <span
                                    class="text-body-1 font-weight-bold text-grey-darken-4"
                                    style="line-height: 1.4"
                                  >
                                    {{ poll.question }}
                                  </span>
                                </div>
                                <div
                                  class="d-flex flex-wrap ms-9"
                                  style="gap: 6px"
                                >
                                  <v-chip
                                    v-for="(opt, i) in poll.options"
                                    :key="i"
                                    size="small"
                                    density="compact"
                                    color="grey-darken-2"
                                    variant="tonal"
                                  >
                                    {{ opt }}
                                  </v-chip>
                                </div>
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions
                                class="pa-2 bg-grey-lighten-5 rounded-b-xl"
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  :color="
                                    copiedIndex === index
                                      ? 'success'
                                      : 'deep-purple-accent-2'
                                  "
                                  variant="text"
                                  size="small"
                                  :prepend-icon="
                                    copiedIndex === index
                                      ? 'mdi-check-circle'
                                      : 'mdi-content-copy'
                                  "
                                  class="text-none font-weight-bold px-3 transition-swing"
                                  @click="copyPollToForm(poll, index)"
                                >
                                  {{
                                    copiedIndex === index
                                      ? "Copied to Form!"
                                      : "Use this Poll"
                                  }}
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </div>
                        </v-slide-y-transition>

                        <div
                          v-if="!isGenerating && !parsedAiPolls && aiResponse"
                          class="mt-2"
                        >
                          <v-sheet
                            class="pa-4 rounded-xl border bg-white"
                            elevation="0"
                          >
                            <div
                              class="text-body-2 text-grey-darken-4"
                              style="white-space: pre-wrap; line-height: 1.6"
                            >
                              {{ aiResponse }}
                            </div>
                          </v-sheet>
                        </div>
                      </div>

                      <div class="flex-shrink-0 mt-auto pt-2 bg-grey-lighten-5">
                        <v-textarea
                          v-model="aiPrompt"
                          placeholder="Ask AI to draft a poll..."
                          variant="solo"
                          elevation="0"
                          bg-color="white"
                          density="compact"
                          rows="1"
                          auto-grow
                          max-rows="4"
                          hide-details
                          class="ai-chat-input border rounded-xl"
                          @keydown.enter.prevent="submitPrompt"
                        >
                          <template v-slot:append-inner>
                            <v-fade-transition>
                              <v-btn
                                v-if="aiPrompt || aiResponse"
                                icon="mdi-broom"
                                size="small"
                                color="grey-darken-1"
                                variant="text"
                                class="ms-1"
                                :disabled="isGenerating"
                                @click="clearAI"
                              ></v-btn>
                            </v-fade-transition>

                            <v-btn
                              icon="mdi-send"
                              size="small"
                              color="deep-purple-accent-2"
                              variant="tonal"
                              elevation="0"
                              class="ms-1"
                              :loading="isGenerating"
                              :disabled="!aiPrompt.trim()"
                              @click="submitPrompt"
                            ></v-btn>
                          </template>
                        </v-textarea>
                      </div>
                    </div>
                  </v-window-item>
                </v-window>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-divider class="mt-2"></v-divider>
        <v-card-actions class="pa-3 bg-white flex-shrink-0 border-t">
          <v-spacer></v-spacer>
          <v-btn variant="plain" size="small" @click="closeDialog"
            >Cancel</v-btn
          >
          <v-btn
            :loading="loading"
            class="bg-gradient-primary px-4"
            color="white"
            size="small"
            variant="flat"
            @click="CreateEditPollMethod"
          >
            Confirm & Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
import { createNewPoll, editPoll } from "@/graphql/mutations";
import SnackbarComp from "@/components/Extras/SnackbarComp.vue";
import { UpdateScratchPadText } from "@/mixins/Extras/UpdateScratchPadText";
import { AskAIForResponse } from "@/mixins/Extras/AskAIForResponse";

const client = generateClient();

export default {
  name: "PollDialog",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    selectedPoll: {
      type: Object,
      default: null,
    },
    statusAction: {
      type: String,
      enum: ["activate", "deactivate"],
      default: "activate",
    },
    internalPincodes: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    SnackbarComp,
  },
  mixins: [UpdateScratchPadText, AskAIForResponse],
  model: {
    prop: "dialog",
    event: "update:dialog",
  },
  emits: ["update:dialog", "clicked"],
  data() {
    return {
      copiedIndex: null,
      ask: false,
      loading: false,
      internalDialog: false,
      startDateTimeMenu: false,
      isGenerating: false,

      activeTab: "scratchpad",
      otherCategory: "",
      selectedCountry: "ALL",
      selectedState: "ALL",
      selectedDistrict: "ALL",
      selectedPincode: "ALL",
      aiPrompt: "",
      aiResponse: "",

      formData: {
        title: "",
        description: "",
        enable_app_notification: false,
        options: ["", ""],
        category: "General",
        age_group: "ALL",
        startDate: new Date(),
        start_time: null,
        pollEnsIn: "24 hours",
        knowledge_base_url: "",
      },
      categories: [
        "General",
        "Technology",
        "Politics",
        "Sports",
        "Entertainment",
        "Business",
        "Health",
        "Lifestyle",
        "Society",
        "Education",
        "Travel",
        "Others",
      ],
      SnackbarComponent: {
        SnackbarVmodel: false,
        SnackbarText: "",
        SnackbarColor: "success",
      },
      confirmationText: "",
      required: (value) => !!value || "Required",
    };
  },
  computed: {
    parsedAiPolls() {
      if (!this.aiResponse) return null;

      try {
        // If the API already returned it as a JavaScript object/array
        if (typeof this.aiResponse === "object") {
          // Return the array directly, or look inside a 'result' key if it has one
          return Array.isArray(this.aiResponse)
            ? this.aiResponse
            : this.aiResponse.result || null;
        }

        // If the API returned a string, find the JSON array inside it using Regex
        // This prevents crashes if the AI adds text like "Here are your polls:" before the JSON
        const match = this.aiResponse.match(/\[\s*\{[\s\S]*\}\s*\]/);

        if (match) {
          return JSON.parse(match[0]);
        }
      } catch (error) {
        console.error("Could not parse AI response into polls:", error);
        return null; // Fallback to plain text view
      }
      return null;
    },
    minDate() {
      // Returns today's date formatted perfectly for Vuetify (YYYY-MM-DD)
      const now = new Date();
      return new Date(now.getTime() - now.getTimezoneOffset() * 60000)
        .toISOString()
        .substring(0, 10);
    },
    isValidDateTime() {
      // 1. Must have both date and time selected
      if (!this.formData.startDate || !this.formData.start_time) return false;

      // 2. Parse the selected Date
      const selectedDateTime = new Date(this.formData.startDate);
      const now = new Date();

      // 3. Parse the selected Time (handles both 12h AM/PM and 24h formats)
      let timeStr = this.formData.start_time;
      let hours = 0;
      let minutes = 0;

      if (timeStr.includes("AM") || timeStr.includes("PM")) {
        let [timePart, modifier] = timeStr.split(" ");
        let [h, m] = timePart.split(":");
        hours = parseInt(h);
        minutes = parseInt(m);
        if (modifier === "PM" && hours !== 12) hours += 12;
        if (modifier === "AM" && hours === 12) hours = 0;
      } else {
        let [h, m] = timeStr.split(":");
        hours = parseInt(h);
        minutes = parseInt(m);
      }

      // Apply the hours and minutes to the selected date
      selectedDateTime.setHours(hours, minutes, 0, 0);

      // 4. Validate: The selected combined date/time must be strictly greater than or equal to RIGHT NOW.
      return selectedDateTime.getTime() >= now.getTime();
    },
    availableStates() {
      if (!this.internalPincodes || this.selectedCountry === "ALL") return [];

      const states = new Set(
        this.internalPincodes
          // Filter by the selected country first!
          .filter((item) => item.Country === this.selectedCountry)
          .map((item) => item.StateName),
      );
      return Array.from(states).filter(Boolean).sort();
    },
    availableDistricts() {
      if (!this.internalPincodes || this.selectedState === "ALL") return [];
      const districts = new Set(
        this.internalPincodes
          .filter((item) => item.StateName === this.selectedState)
          .map((item) => item.District),
      );
      return Array.from(districts).filter(Boolean).sort();
    },
    availablePincodes() {
      if (!this.internalPincodes || this.selectedDistrict === "ALL") return [];
      const pincodes = new Set(
        this.internalPincodes
          .filter(
            (item) =>
              item.District === this.selectedDistrict &&
              item.StateName === this.selectedState,
          )
          .map((item) => item.Pincode),
      );
      return Array.from(pincodes).filter(Boolean).sort();
    },

    // --- CURATOR LOCKING LOGIC ---
    currentUser() {
      return this.$store?.getters?.get_current_user_details || {};
    },
    isCurator() {
      return this.currentUser.user_role === "CURATOR";
    },
    curatorTargetType() {
      return this.currentUser.user_target_type || "GLOBAL";
    },
    curatorTargetValue() {
      return this.currentUser.user_target_value || "GLOBAL";
    },
    isCountryDisabled() {
      if (this.selectedPoll?.type === "edit") return true;
      return this.isCurator; // Completely locks the dropdown for Curators
    },
    isStateDisabled() {
      if (this.selectedPoll?.type === "edit") return true;
      return this.isCurator;
    },
    isDistrictDisabled() {
      if (this.selectedPoll?.type === "edit") return true;
      return this.isCurator;
    },
    isPincodeDisabled() {
      if (this.selectedPoll?.type === "edit") return true;
      return this.isCurator;
    },
  },
  watch: {
    async dialog(newVal) {
      this.internalDialog = newVal;
      if (
        (newVal && this.selectedPoll?.type === "edit") ||
        this.selectedPoll?.type === "repoll"
      ) {
        this.$nextTick(() => {
          let initialDate = new Date();
          let initialTimeStr = this.getCurrentTime();

          if (this.selectedPoll.start_time) {
            const tStartTime = this.selectedPoll.start_time;

            if (typeof tStartTime === "number" || !isNaN(Number(tStartTime))) {
              const parsedDate = new Date(Number(tStartTime));
              initialDate = parsedDate;

              const hrs = String(parsedDate.getHours()).padStart(2, "0");
              const mins = String(parsedDate.getMinutes()).padStart(2, "0");
              initialTimeStr = `${hrs}:${mins}`;
            } else if (
              typeof tStartTime === "string" &&
              tStartTime.includes(":")
            ) {
              initialTimeStr = tStartTime;
              if (this.selectedPoll.startDate) {
                initialDate = new Date(this.selectedPoll.startDate);
              }
            }
          }

          this.formData = {
            title: this.selectedPoll.title || "",
            options: this.selectedPoll.options
              ? this.selectedPoll.options.map((opt) => opt.text)
              : ["", ""],
            enable_app_notification:
              this.selectedPoll.enable_app_notification || false,
            startDate: initialDate,
            start_time: initialTimeStr,
            pollEnsIn: this.selectedPoll.pollEnsIn || "24 hours",
            knowledge_base_url: this.selectedPoll.knowledge_base_url || "",
            category: this.selectedPoll.category || "General",
            age_group: this.selectedPoll.age_group || "ALL",
          };

          this.formData.startDate = new Date();
          this.formData.start_time = this.getCurrentTime();

          const tType = this.selectedPoll.target_type || "GLOBAL";
          const tVal = this.selectedPoll.target_value || "GLOBAL";
          this.setGeoHierarchy(tType, tVal);
        });
      } else if (newVal) {
        this.resetForm();
      } else if (!newVal) {
        this.resetForm();
      }

      this.formData.description = this.$store.getters.get_scratch_pad_text;
    },
    internalDialog(newVal) {
      this.$emit("update:dialog", newVal);
    },
    startDateTimeMenu(newVal) {
      if (newVal && !this.formData.start_time) {
        this.formData.start_time = this.getCurrentTime();
      }
    },
    selectedState(val) {
      if (val && val !== "ALL") {
        this.formData.enable_app_notification = true;
      }
    },
  },
  methods: {
    clearAI() {
      this.aiPrompt = "";
      this.aiResponse = "";
      this.copiedIndex = null;
    },
    copyPollToForm(poll) {
      this.formData.title = poll.question;
      this.formData.options = [...poll.options];
    },
    async submitPrompt() {
      if (!this.aiPrompt.trim()) return;

      this.isGenerating = true;
      this.aiResponse = "";

      try {
        this.aiResponse = await this.AskAIForResponseMethod(this.aiPrompt);
        console.log("Rwespo : ", this.aiResponse);
      } catch (error) {
        console.error("Error generating response:", error);
        this.aiResponse =
          "An error occurred while fetching the response. Please try again.";
      } finally {
        this.isGenerating = false;
      }
    },

    isToday(date) {
      if (!date) return false;
      const d = new Date(date);
      const today = new Date();
      return (
        d.getDate() === today.getDate() &&
        d.getMonth() === today.getMonth() &&
        d.getFullYear() === today.getFullYear()
      );
    },

    allowedHours(h) {
      if (!this.isToday(this.formData.startDate)) return true;
      const currentHour = new Date().getHours();
      return h >= currentHour;
    },

    allowedMinutes(m) {
      if (m % 5 !== 0) return false;
      if (!this.isToday(this.formData.startDate)) return true;

      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();

      let selectedHour = null;
      if (this.formData.start_time) {
        let timeStr = this.formData.start_time;
        if (timeStr.includes("AM") || timeStr.includes("PM")) {
          let [timePart, modifier] = timeStr.split(" ");
          let [hStr] = timePart.split(":");
          selectedHour = parseInt(hStr);
          if (modifier === "PM" && selectedHour !== 12) selectedHour += 12;
          if (modifier === "AM" && selectedHour === 12) selectedHour = 0;
        } else {
          selectedHour = parseInt(timeStr.split(":")[0]);
        }
      }

      if (selectedHour === currentHour) {
        return m >= currentMinute;
      }

      return true;
    },

    setGeoHierarchy(tType, tVal) {
      this.selectedCountry = "ALL";
      this.selectedState = "ALL";
      this.selectedDistrict = "ALL";
      this.selectedPincode = "ALL";

      if (tType === "COUNTRY") {
        this.selectedCountry = tVal;
      } else if (tType === "STATE") {
        this.selectedCountry = "INDIA";
        this.selectedState = tVal;
      } else if (tType === "DISTRICT") {
        this.selectedCountry = "INDIA";
        const loc = this.internalPincodes.find((p) => p.District === tVal);
        if (loc) this.selectedState = loc.StateName;
        this.selectedDistrict = tVal;
      } else if (tType === "PINCODE") {
        this.selectedCountry = "INDIA";
        const loc = this.internalPincodes.find((p) => p.Pincode === tVal);
        if (loc) {
          this.selectedState = loc.StateName;
          this.selectedDistrict = loc.District;
        }
        this.selectedPincode = tVal;
      }
    },
    onCountryChange() {
      if (this.selectedPoll?.type === "edit") return;
      this.selectedState = "ALL";
      this.selectedDistrict = "ALL";
      this.selectedPincode = "ALL";
    },
    onStateChange() {
      if (this.selectedPoll?.type === "edit") return;
      this.selectedDistrict = "ALL";
      this.selectedPincode = "ALL";
    },
    onDistrictChange() {
      if (this.selectedPoll?.type === "edit") return;
      this.selectedPincode = "ALL";
    },
    getCurrentTime() {
      const now = new Date();

      // Format back to HH:MM
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");

      return `${hours}:${minutes}`;
    },
    clearDateTime() {
      this.formData.startDate = null;
      this.formData.start_time = null;
      this.startDateTimeMenu = false;
    },
    formatDateTime(date, time) {
      if (!date || !time) return "";
      if (typeof time !== "string") return "";
      if (!time.includes(":")) return "";

      const dateObj = date instanceof Date ? date : new Date(date);
      let hours = 0;
      let minutes = 0;

      if (time.includes("AM") || time.includes("PM")) {
        let [timePart, modifier] = time.split(" ");
        let [h, m] = timePart.split(":");
        hours = parseInt(h);
        minutes = parseInt(m);
        if (modifier === "PM" && hours !== 12) hours += 12;
        if (modifier === "AM" && hours === 12) hours = 0;
      } else {
        let [h, m] = time.split(":");
        hours = parseInt(h);
        minutes = parseInt(m);
      }

      const timeObj = new Date(dateObj);
      timeObj.setHours(hours, minutes);

      const formattedDate = dateObj.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
      const formattedTime = timeObj.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });

      return `${formattedDate} at ${formattedTime}`;
    },
    resolveTargetPayload() {
      let type = "GLOBAL";
      let value = "GLOBAL";

      if (this.selectedCountry !== "ALL") {
        type = "COUNTRY";
        value = this.selectedCountry;
        if (this.selectedState !== "ALL") {
          type = "STATE";
          value = this.selectedState;
          if (this.selectedDistrict !== "ALL") {
            type = "DISTRICT";
            value = this.selectedDistrict;
            if (this.selectedPincode !== "ALL") {
              type = "PINCODE";
              value = this.selectedPincode;
            }
          }
        }
      }
      return { target_type: type, target_value: value };
    },
    async CreateEditPollMethod() {
      if (this.selectedPoll?.type !== "edit") {
        const { valid } = await this.$refs.pollForm.validate();
        if (!valid) {
          this.SnackbarComponent.SnackbarText =
            "Please fill in all required fields.";
          this.SnackbarComponent.SnackbarColor = "error";
          this.SnackbarComponent.SnackbarVmodel = true;
          return;
        }
      }

      const startDateTime = new Date(this.formData.startDate);
      if (this.formData.start_time) {
        let timeStr = this.formData.start_time;
        let hours = 0,
          minutes = 0;

        if (timeStr.includes("AM") || timeStr.includes("PM")) {
          let [timePart, modifier] = timeStr.split(" ");
          let [h, m] = timePart.split(":");
          hours = parseInt(h);
          minutes = parseInt(m);
          if (modifier === "PM" && hours !== 12) hours += 12;
          if (modifier === "AM" && hours === 12) hours = 0;
        } else {
          let [h, m] = timeStr.split(":");
          hours = parseInt(h);
          minutes = parseInt(m);
        }
        startDateTime.setHours(hours, minutes, 0, 0);
      }
      const startEpoch = startDateTime.getTime();

      const hoursToAdd = parseInt(this.formData.pollEnsIn.split(" ")[0]);
      const endEpoch = startEpoch + hoursToAdd * 60 * 60 * 1000;

      let formOptions = [];
      let voteCountsObj = {};
      this.formData.options.forEach((opt, ind) => {
        const optKey = `opt_${ind + 1}`;
        formOptions.push({ optionId: optKey, text: opt });
        voteCountsObj[optKey] = 0;
      });

      const targetData = this.resolveTargetPayload();

      let pollObj = {
        title: this.formData.title,
        options: formOptions,
        enable_app_notification: this.formData.enable_app_notification,
        target_type: targetData.target_type,
        target_value: targetData.target_value,
        age_group: this.formData.age_group,
        start_time: startEpoch,
        end_time: endEpoch,
        is_replicated_poll:
          this.selectedPoll?.type == "repoll" ? true : undefined,
        replicated_poll_id:
          this.selectedPoll?.type == "repoll"
            ? this.selectedPoll.pollId
            : undefined,
        knowledge_base_url: this.formData.knowledge_base_url || undefined,
        // category: this.formData.category,
        vote_counts: JSON.stringify(voteCountsObj),
      };

      if (this.selectedPoll?.type === "edit") {
        pollObj = {
          pollId: this.selectedPoll.pollId,
          title: this.formData.title,
          options: formOptions,
          // category: this.formData.category,
        };
      }

      if (this.selectedPoll?.type == "repoll") {
      }

      try {
        this.loading = true;
        let result = await client.graphql({
          query: this.selectedPoll?.type === "edit" ? editPoll : createNewPoll,
          variables: {
            input: {
              user_id: this.$store.getters.get_current_user_details.user_id,
              ...pollObj,
            },
          },
        });
        const mutationName =
          this.selectedPoll?.type === "edit" ? "editPoll" : "createNewPoll";
        var ResultObj = result.data[mutationName];

        if (
          this.formData.description !== this.$store.getters.get_scratch_pad_text
        ) {
          await this.UpdateScratchPadTextMethod(this.formData.description);
        }

        if (
          this.selectedPoll?.type !== "edit" &&
          ResultObj?.message == "SUCCESS"
        ) {
          this.SnackbarComponent.SnackbarText = "Poll saved successfully!";
          this.SnackbarComponent.SnackbarColor = "success";
          this.SnackbarComponent.SnackbarVmodel = true;
          this.$emit("clicked", 2);
          this.closeDialog();
        } else if (
          this.selectedPoll?.type === "edit" &&
          ResultObj.status == "SUCCESS"
        ) {
          this.SnackbarComponent.SnackbarText = "Poll updated successfully!";
          this.SnackbarComponent.SnackbarColor = "success";
          this.SnackbarComponent.SnackbarVmodel = true;
          this.$emit("clicked", 2);
          this.closeDialog();
        } else {
          throw new Error("Unexpected response from server");
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Error", error);
        this.closeDialog();
      }
    },
    addOption() {
      this.formData.options.push("");
    },
    removeOption(index) {
      if (this.formData.options.length > 2) {
        this.formData.options.splice(index, 1);
      }
    },
    closeDialog() {
      this.internalDialog = false;
      this.resetForm();
    },
    resetForm() {
      this.$nextTick(() => {
        if (this.$refs.pollForm) {
          this.$refs.pollForm.resetValidation();
        }

        this.formData = {
          title: "",
          options: ["", ""],
          category: "General",
          // description: this.$store.getters.get_scratch_pad_text,
          enable_app_notification: false,
          age_group: "ALL",
          startDate: new Date(),
          start_time: this.getCurrentTime(),
          pollEnsIn: "24 hours",
          knowledge_base_url: "",
        };

        this.otherCategory = "";

        if (this.isCurator) {
          this.setGeoHierarchy(this.curatorTargetType, this.curatorTargetValue);
        } else {
          this.setGeoHierarchy("GLOBAL", "GLOBAL");
        }
      });
    },
  },
};
</script>

<style scoped>
/* Add this below your existing ai-gradient-text styles */
.ai-poll-card {
  border-color: rgba(0, 0, 0, 0.08); /* Very subtle default border */
}

.ai-poll-card:hover {
  border-color: rgba(142, 36, 170, 0.4) !important; /* Purple border on hover */
  background-color: #faf8fc; /* Very faint purple tint */
}
/* Gemini-style Blue to Purple Gradient */
.ai-gradient-text {
  background: linear-gradient(90deg, #1a73e8, #8e24aa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}

/* Gradient Button */
.ai-generate-btn {
  background: linear-gradient(90deg, #1a73e8, #8e24aa) !important;
  color: white !important;
  border-radius: 24px; /* Pill shape */
  transition: opacity 0.3s ease;
}

.ai-generate-btn:hover {
  opacity: 0.9;
}

/* AI Response Bubble Background */
.ai-response-sheet {
  background: linear-gradient(135deg, #f0f4ff 0%, #f6f0ff 100%);
  border: 1px solid rgba(142, 36, 170, 0.1);
}

/* Pulsing Animation for the Icon */
@keyframes ai-pulse {
  0% {
    transform: scale(1);
    opacity: 1;
    filter: brightness(1);
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
    filter: brightness(1.2);
  }
  100% {
    transform: scale(1);
    opacity: 1;
    filter: brightness(1);
  }
}

.ai-pulse-animation {
  animation: ai-pulse 1.5s infinite ease-in-out;
}

.btn-primary-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}
.bg-gradient-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}

.custom-date-picker :deep(.v-date-picker) {
  background: transparent !important;
}

.custom-date-picker :deep(.v-date-picker__header) {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
}

.custom-date-picker :deep(.v-date-picker-header__month),
.custom-date-picker :deep(.v-date-picker-header__year) {
  color: white !important;
}

.custom-date-picker :deep(.v-btn.v-btn--active) {
  color: white !important;
  background-color: #667eea !important;
}

.custom-time-picker :deep(.v-time-picker) {
  background: transparent !important;
}

.custom-time-picker :deep(.v-time-picker__header) {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
}

.custom-time-picker :deep(.v-time-picker__clock) {
  border-color: #667eea !important;
}

.custom-time-picker :deep(.v-time-picker-clock__needle),
.custom-time-picker :deep(.v-time-picker-clock__hand) {
  background-color: #667eea !important;
}

.cursor-pointer {
  cursor: pointer;
}

.gap-2 {
  gap: 8px;
}

.border-s {
  border-left: 1px solid #e0e0e0;
}
.border-t {
  border-top: 1px solid #e0e0e0;
}
</style>
